import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app.js';
import './index.css';
import './styles.css';
import './assets/fonts/WSfont.ttf';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);